module.exports = __webpack_public_path__ + "img/29-indicadores-analises-hub.547e5d67.png";